import React, { useState } from 'react'
import { components } from 'react-select'
import styled from 'styled-components'
import SelectWithAll from './SelectAll'

const OptionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const allOption = {
  label: 'Select all',
  value: '*'
}

const MultiWrapper = styled.div`
  background: var(--color-primary);
  margin-left: 10px;
  color: var(--surface-bg);
  font-size: 85%;
`
const Checked = styled.span`
  display: inline-block;
  transform: rotate(35deg);
  height: 16px;
  width: 8px;
  border-bottom: 1px solid var(--text-heading);
  border-right: 1px solid var(--text-heading);
`

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <OptionsWrapper>
          <label>{props.label}</label>
          {props.isSelected && <Checked />}
        </OptionsWrapper>
      </components.Option>
    </div>
  )
}

const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue()
  const isMoreOptionsSelected = currentValues && currentValues.length > 1
  let toBeRendered = children
  if (isMoreOptionsSelected) {
    toBeRendered = `${currentValues.length} items selected`
  }

  if (currentValues.some((val) => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]]
  }

  return <components.ValueContainer {...props}>{toBeRendered}</components.ValueContainer>
}

const MultiValue = (props) => {
  let labelToBeDisplayed = `${props.data.label} `
  if (props.data.value === allOption.value) {
    labelToBeDisplayed = 'All is selected'
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  )
}

const MultiSelectAll = ({
  options,
  placeholder,
  handleFilterChange,
  multi,
  closeMenuOnSelect,
  selectedValues,
  isClearable
}) => {
  const selectStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'var(--surface-bg, white)',
      borderColor: 'var(--border-strong, #ededed)'
    }),
    menu: (styles) => ({ ...styles, backgroundColor: 'var(--surface-bg, white)' }),
    menuList: (styles) => ({ ...styles, backgroundColor: 'var(--surface-bg, white)' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      color: 'var(--text-heading)',
      backgroundColor: isSelected
        ? 'var(--brand-accent-bg, rgba(5,90,96,0.1))'
        : isFocused
        ? 'var(--item-hover-bg, #f0f0f0)'
        : 'var(--surface-bg, white)',
      ':active': {
        backgroundColor: 'var(--brand-accent-bg, rgba(5,90,96,0.1))'
      }
    }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, fontSize: '12px' }),
    valueContainer: (styles) => ({
      ...styles,
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontSize: '12px',
      color: 'var(--color-primary)'
    }),
    singleValueLabel: (styles, { data }) => ({ ...styles, color: 'var(--color-primary)' }),
    multiValue: (styles, { data }) => ({
      ...styles,
      backgroundColor: 'var(--surface-bg)'
    }),
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'var(--color-primary)'
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'var(--color-primary)',
      ':hover': {
        backgroundColor: 'var(--surface-bg)',
        color: 'var(--color-primary)'
      }
    })
  }

  return (
    <>
      <SelectWithAll
        options={options}
        isMulti={multi}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={false}
        components={{
          Option,
          ValueContainer,
          MultiValue
        }}
        onChange={handleFilterChange}
        allowSelectAll={false}
        value={selectedValues}
        styles={selectStyles}
        placeholder={placeholder}
        isClearable={isClearable}
      />
    </>
  )
}

export default MultiSelectAll
